import { render, staticRenderFns } from "./FileItemCard.vue?vue&type=template&id=b75d3580&scoped=true&"
import script from "./FileItemCard.vue?vue&type=script&lang=js&"
export * from "./FileItemCard.vue?vue&type=script&lang=js&"
import style0 from "./FileItemCard.vue?vue&type=style&index=0&id=b75d3580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75d3580",
  null
  
)

export default component.exports